var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 0H15.428V1.71429H10.2852V0Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57115 1.71436H10.2854V5.14293H15.4283V1.71436H17.1426V3.42864H18.8569V5.14293H17.1426V6.85721H8.57115V5.14293H5.14258V3.42864H8.57115V1.71436Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85742 8.57141H10.286V10.2857H6.85742V8.57141Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 8.57141H18.8563V10.2857H15.4277V8.57141Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 10.2856H6.85686V11.9999H5.14258V10.2856Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 10.2856H11.9994V11.9999H10.2852V10.2856Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 10.2856H15.4291V11.9999H13.7148V10.2856Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 10.2856H20.5717V11.9999H18.8574V10.2856Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42773 12H5.14202V13.7143H3.42773V12Z",
    fill: "#1A1A1A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H13.7143V15.4286H12V12Z",
    fill: "#1A1A1A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 12H22.2866V13.7143H20.5723V12Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 13.7144H3.42913V15.4286H1.71484V13.7144Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 13.7144H18.8569V15.4286H17.1426V13.7144Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2852 13.7144H23.9994V15.4286H22.2852V13.7144Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.4286H1.71429V18.8572H0V15.4286Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85686 15.4286H8.57115V24H6.85686V18.8572H5.14258V17.1429H6.85686V15.4286Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 15.4286H17.142V17.1429H15.4277V15.4286Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 15.4286H22.2866V17.1429H20.5723V15.4286Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 17.1428H15.4291V18.8571H13.7148V17.1428Z",
    fill: "#1A1A1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8563 17.1428H20.5706V24H18.8563V20.5714H15.4277V18.8571H18.8563V17.1428Z",
    fill: "#1A1A1A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 18.8572H5.14342V20.5715H1.71484V18.8572Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 22.2856H13.7151V23.9999H18.858V25.7142H8.57227V23.9999H12.0008V22.2856Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.3f03b4dd.svg";
export { ForwardRef as ReactComponent };